import { useOutletContext } from "react-router";

interface RootOutletContext {
  eventSubdomain: string | null;
}

export function useEventSubdomain(): string | null {
  const { eventSubdomain } = useOutletContext<RootOutletContext>();
  return eventSubdomain;
}
